module.exports = __webpack_public_path__ + "img/0Q3A5061_P_L_Wood.700e846d.jpg";